module.exports = __webpack_public_path__ + "img/laboratorio_16-9_1440.4217e1a8.jpg";